import { Link, useLocation } from "react-router-dom";
import HomeFillSVG, {
  ChatFillSVG,
  ChatSVG,
  FavFillSVG,
  FavSVG,
  HomeSVG,
  ListFillSVG,
  ListSVG,
} from "./HeaderSVGs";
import { UserAuth } from "../Context";
import { useFetchUserData } from "../hooks/user/useFetchUserData";
import BottomTray from "../Trays/BottomTray";
import Profile from "../Trays/Profile";
import { useState } from "react";

const NavbarItems = ({ SVG, text, link }) => {
  return (
    <Link
      to={link}
      className="d-flex flex-column align-items-center"
      style={{ gap: "4px", width: "52px" }}
    >
      <SVG />
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: "400",
          fontSize: "12px",
          lineHeight: "16px",
          letterSpacing: "0%",
          color: "#676A79",
        }}
      >
        {text}
      </div>
    </Link>
  );
};

const MobileScreenHeader = () => {
  const { user } = UserAuth();
  const { userData } = useFetchUserData(user?.uid);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const handleImageError = (e, userData) => {
    const avatarInitials = userData?.userName
      ? userData?.userName[0]?.toUpperCase()
      : userData?.displayName?.toUpperCase();
    e.target.onerror = null; // Prevents infinite loop in case fallback also fails
    e.target.src = `https://ui-avatars.com/api/?name=${avatarInitials}`;
  };
  return (
    <div
      className="d-block d-md-none bg-mode"
      style={{ position: "fixed", bottom: 0, width: "100%", zIndex: 1051 }}
    >
      <div
        className="d-flex align-items-center justify-content-around"
        style={{ padding: "7px 10px" }}
      >
        <NavbarItems
          SVG={
            location.pathname === "/" || location.pathname === "/discover"
              ? HomeFillSVG
              : HomeSVG
          }
          text={"Home"}
          link={"/discover"}
        />
        <NavbarItems
          SVG={
            location.pathname === `/userProfile/${user?.uid}/favorites`
              ? FavFillSVG
              : FavSVG
          }
          text={"Favorites"}
          link={`/userProfile/${user?.uid}/favorites`}
        />
        <NavbarItems
          SVG={
            location.pathname === `/userProfile/${user?.uid}/shoppinglist`
              ? ListFillSVG
              : ListSVG
          }
          text={"Lists"}
          link={`/userProfile/${user?.uid}/shoppinglist`}
        />
        <NavbarItems
          SVG={location.pathname === "/chat" ? ChatFillSVG : ChatSVG}
          text={"Chat"}
          link={"/chat"}
        />
        <div
          className="d-flex flex-column align-items-center"
          style={{ gap: "4px", width: "52px" }}
          onClick={() => setIsOpen(true)}
        >
          <div
            style={{ width: "24px", height: "24px" }}
            className="d-flex align-items-center justify-content-center"
          >
            <img
              src={
                userData?.photo ||
                `https://ui-avatars.com/api/?name=${userData?.userName[0]?.toUpperCase()}`
              }
              onError={(e) => {
                handleImageError(e, user);
              }}
              width={"20px"}
              height={"20px"}
              style={{ borderRadius: "4px" }}
              alt=""
            />
          </div>
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "16px",
              letterSpacing: "0%",
              color: "#676A79",
            }}
          >
            Profile
          </div>
        </div>
        <BottomTray isOpen={isOpen} setIsOpen={setIsOpen}>
          <Profile />
        </BottomTray>
      </div>
    </div>
  );
};

export default MobileScreenHeader;
